module.exports = __webpack_public_path__ + "static/media/logo.c227ce20.svg";